export const dashboardWidgets = {
  upcoming: {
    title: "Próximas llegadas",
    empty: "No hay eventos próximos",
    createBooking: "Crear reserva",
  },
  lastActivity: {
    title: "Ultima actividad",
  },
  portals: {
    title: "Canales de reserva sincronizados",
    connectedSuccess: "Conectado con éxito",
    unknownChannel: "Desconocido",
    connectNewChannel: "Conectar un nuevo canal",
    empty: "No tiene canales de conexión sincronizados",
    connectChannel: "Conectar un canal",
    loadError: "No se han podido cargar los portales",
    errorTitle: "Error",
  },
};
